import React from 'react'

export default function Team() {
  return (
    <div id="content" className="site-content">
  <div className="page-header dtable text-center" style={{ backgroundImage: "url(resources/images/banner-.jpg)" }}>
    <div className="dcell">
      <div className="container p-tb110">
        <h1 className="page-title">Our Leadership Team</h1>
        <p className="m-b0">
          We have experience working with large and small businesses and are ready
          to<br />develop a targeted strategy and plan that’s just right for you.
        </p>
        <ul id="breadcrumbs" className="breadcrumbs">
          <li><a href="#">Home</a></li>
          <li className="active">Professional Team</li>
        </ul>
      </div>
    </div>
  </div>

  {/* <section className="p-tb110 bg-team"> */}
    {/* <div className="container"> */}
      {/* <div className="row">
        <div className="col-md-12 col-xs-12">
          <div className="team-image text-center"> <img src="resources/images/4380.jpg" alt="" /> </div>
        </div>
      </div> */}
      {/* <div className="row">
        <div className="col-md-12 col-xs-12 team--top">
          <div className="team-block">
            <div className="ot-heading text-light">
              <h6><span>skilled team</span></h6>
              <h2 className="main-heading">Meet Our<br />Executive Team<br />Members</h2>
            </div>
            <p className="text-light m-b0">If we had a ‘secret sauce’ it would be our awesome people.</p>
          </div>
        </div>
      </div> */}
      {/* <div className="row">
        <div className="col-md-12">
          <div className="partners p-t105">
            <div className="owl-carousel home-client-carousel">
              <div className="partners-slide">
                <a href="#" className="client-logo">
                  <figure className="partners-slide-inner m-a0">
                    <img className="partners-slide-image" src="resources/images/client-logo-1.svg" alt="" />
                  </figure>
                </a>
              </div>
              <div className="partners-slide">
                <a href="#" className="client-logo">
                  <figure className="partners-slide-inner m-a0">
                    <img className="partners-slide-image" src="resources/images/client-logo-2.svg" alt="" />
                  </figure>
                </a>
              </div>
              <div className="partners-slide">
                <a href="#" className="client-logo">
                  <figure className="partners-slide-inner m-a0">
                    <img className="partners-slide-image" src="resources/images/client-logo-3.png" alt="" />
                  </figure>
                </a>
              </div>
              <div className="partners-slide">
                <a href="#" className="client-logo">
                  <figure className="partners-slide-inner m-a0">
                    <img className="partners-slide-image" src="resources/images/client-logo-4.svg" alt="" />
                  </figure>
                </a>
              </div>
              <div className="partners-slide">
                <a href="#" className="client-logo">
                  <figure className="partners-slide-inner m-a0">
                    <img className="partners-slide-image" src="resources/images/client-logo-5.svg" alt="" />
                  </figure>
                </a>
              </div>
              <div className="partners-slide">
                <a href="#" className="client-logo">
                  <figure className="partners-slide-inner m-a0">
                    <img className="partners-slide-image" src="resources/images/client-logo-6.svg" alt="" />
                  </figure>
                </a>
              </div>
              <div className="partners-slide">
                <a href="#" className="client-logo">
                  <figure className="partners-slide-inner m-a0">
                    <img className="partners-slide-image" src="resources/images/client-logo-1.svg" alt="" />
                  </figure>
                </a>
              </div>
              <div className="partners-slide">
                <a href="#" className="client-logo">
                  <figure className="partners-slide-inner m-a0">
                    <img className="partners-slide-image" src="resources/images/client-logo-2.svg" alt="" />
                  </figure>
                </a>
              </div>
              <div className="partners-slide">
                <a href="#" className="client-logo">
                  <figure className="partners-slide-inner m-a0">
                    <img className="partners-slide-image" src="resources/images/client-logo-3.png" alt="" />
                  </figure>
                </a>
              </div>
              <div className="partners-slide">
                <a href="#" className="client-logo">
                  <figure className="partners-slide-inner m-a0">
                    <img className="partners-slide-image" src="resources/images/client-logo-4.svg" alt="" />
                  </figure>
                </a>
              </div>
              <div className="partners-slide">
                <a href="#" className="client-logo">
                  <figure className="partners-slide-inner m-a0">
                    <img className="partners-slide-image" src="resources/images/client-logo-5.svg" alt="" />
                  </figure>
                </a>
              </div>
              <div className="partners-slide">
                <a href="#" className="client-logo">
                  <figure className="partners-slide-inner m-a0">
                    <img className="partners-slide-image" src="resources/images/client-logo-6.svg" alt="" />
                  </figure>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    {/* </div>
  </section> */}
  <section className="p-b110 bg-light">
  <div className="container">
    {/* <div className="row">
      <div className="col-md-12 m-b35 text-center">
        <div className="ot-heading">
          <h6><span>professional people</span></h6>
          <h2 className="main-heading">Our Leadership Team</h2>
        </div>
        <p className="m-b0">We have experience working with large and small businesses and are ready
          to<br />develop a targeted strategy and plan that’s just right for you.</p>
      </div>
    </div> */}
    <div className="row">
      <div className="col-md-4 col-sm-6 col-xs-12 m-b55">
        <div className="team-wrap">
          <div className="team-thumb">
            <img src="resources/images/developer-1.jpg" alt="" />
          </div>
          <div className="team-info">
            <h4>Surya Pr. Singh</h4>
            <span>Sr. React / Angular Dev</span>
            <div className="team-social">
              <a className="github" target="_blank" rel="noopener noreferrer" href="https://github.com/SuryaPratapSing"><i className="fa-brands fa-github"></i></a>
              <a className="linkedin" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/iamsinghsurya/"><i className="fa-brands fa-linkedin-in"></i></a>
              <span className="flaticon-add-1"></span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4 col-sm-6 col-xs-12 m-b55">
        <div className="team-wrap">
          <div className="team-thumb">
            <img src="resources/images/developer-2.jpg" alt="" />
          </div>
          <div className="team-info">
            <h4>Anshuman Patel</h4>
            <span>Sr. Ruby on Rails Dev</span>
            <div className="team-social">
              <a className="github" target="_blank" rel="noopener noreferrer" href="https://github.com/anshumanpate"><i className="fa-brands fa-github"></i></a>
              <a className="linkedin" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/anshuman-patel-92b335268/"><i className="fa-brands fa-linkedin-in"></i></a>
              <span className="flaticon-add-1"></span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4 col-sm-6 col-xs-12 m-b55">
        <div className="team-wrap">
          <div className="team-thumb">
            <img src="resources/images/developer-3.jpg" alt="" />
          </div>
          <div className="team-info">
            <h4>Vivek Singh</h4>
            <span>Sr. Python Dev</span>
            <div className="team-social">
              <a className="github" target="_blank" rel="noopener noreferrer" href="https://github.com/viveksingh75"><i className="fa-brands fa-github"></i></a>
              <a className="linkedin" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/viveksingh75099/"><i className="fa-brands fa-linkedin-in"></i></a>
              <span className="flaticon-add-1"></span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4 col-sm-6 col-xs-12 m-b55">
        <div className="team-wrap">
          <div className="team-thumb">
            <img src="resources/images/developer-4.jpg" alt="" />
          </div>
          <div className="team-info">
            <h4>Anchal Ojha</h4>
            <span>Sr. .NET Dev</span>
            <div className="team-social">
              <a className="github" target="_blank" rel="noopener noreferrer" href="https://github.com/AnchalopOjha"><i className="fa-brands fa-github"></i></a>
              <a className="linkedin" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/anchal-ojha-b97200268/"><i className="fa-brands fa-linkedin-in"></i></a>
              <span className="flaticon-add-1"></span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4 col-sm-6 col-xs-12 m-b55">
        <div className="team-wrap">
          <div className="team-thumb">
            <img src="resources/images/developer-6.jpg" alt="" />
          </div>
          <div className="team-info">
            <h4>Salil Tripathi</h4>
            <span>Sr. React Native Dev</span>
            <div className="team-social">
              <a className="github" target="_blank" rel="noopener noreferrer" href="https://github.com/SalilTr"><i className="fa-brands fa-github"></i></a>
              <a className="linkedin" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/salil-tripathi-440534234?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fa-brands fa-linkedin-in"></i></a>
              <span className="flaticon-add-1"></span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4 col-sm-6 col-xs-12 m-b55">
        <div className="team-wrap">
          <div className="team-thumb">
            <img src="resources/images/developer-5.jpg" alt="" />
          </div>
          <div className="team-info">
            <h4>Mohit Sachidev</h4>
            <span>Sr. Node.js Dev</span>
            <div className="team-social">
              <a className="github" target="_blank" rel="noopener noreferrer" href="https://github.com/mohit-2606-sachdev"><i className="fa-brands fa-github"></i></a>
              <a className="linkedin" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/developer-mohit-sachdev/"><i className="fa-brands fa-linkedin-in"></i></a>
              <span className="flaticon-add-1"></span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4 col-sm-6 col-xs-12 sm-m-b55">
        <div className="team-wrap">
          <div className="team-thumb">
            <img src="resources/images/developer-8.jpg" alt="" />
          </div>
          <div className="team-info">
            <h4>Praphull Gautam</h4>
            <span>Sr. DevOps Engineer</span>
            <div className="team-social">
              <a className="github" target="_blank" rel="noopener noreferrer" href="https://github.com/DeveloperPraphull"><i className="fa-brands fa-github"></i></a>
              <a className="linkedin" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/praphull-gautam-8bbb5a270/"><i className="fa-brands fa-linkedin-in"></i></a>
              <span className="flaticon-add-1"></span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4 col-sm-6 col-xs-12 sm-m-b55">
        <div className="team-wrap">
          <div className="team-thumb">
            <img src="resources/images/developer-7.jpg" alt="" />
          </div>
          <div className="team-info">
            <h4>Abhishek Gautam</h4>
            <span>Sr. Java Developer</span>
            <div className="team-social">
              <a className="github" target="_blank" rel="noopener noreferrer" href="https://github.com/abhishek5100/Newsapp-on-rails"><i className="fa-brands fa-github"></i></a>
              <a className="linkedin" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/feed/"><i className="fa-brands fa-linkedin-in"></i></a>
              <span className="flaticon-add-1"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h4 className="developer-section-content">Hire Experienced 50+ developers for your project.</h4>

    <div className="text-center">
      <a href="contact.html" className="ot-btn-main">Contact Us</a>
    </div>
  </div>
</section>
</div>
  )
}
